import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 完整取代選用的檢測種類。payload 含 inspectionKindIds 與 GET 的 updatedAt。 */
export async function replaceSnProductMappingInspectionKinds(id, payload) {
  const { data: raw } = await request.put(
    `/aftersales/sn-product-mapping/${id}/inspection-kinds`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
